import { ICON_TYPE, type IconNameExtended } from "@/components/library/Icon";
import type { SectionBackground } from "@/puck/types";

export const SECTION_BG: Record<SectionBackground, string> = {
  transparent: "",
  surface: "bg-marketing-surface",
  voiceCard: "bg-marketing-voice-card",
  primary: "bg-gail-primary",
  white: "bg-white",
};

export const asIconType = (value: string): ICON_TYPE =>
  (value as ICON_TYPE) || ICON_TYPE.LIGHT;

export const asIconName = (value: string): IconNameExtended =>
  (value || "question") as IconNameExtended;

export const joinClasses = (
  ...classes: Array<string | false | undefined>
): string => classes.filter(Boolean).join(" ");
